const microServices = {
  USER_SERVICE: "/user-service/api",
  USER_SERVICE_WALLET: "/user-service/api/super-admin/campaign/wallet",
  USER_CAMPAIGN_PRICING: "/user-service/api/super-admin/campaign/pricing",
  USER_CAMPAIGN_PRICING_ADMIN: "/api/admin/campaign",
  CRM_ADMIN: "/api/admin",
};
export const endpoints = {
  SUPER_ADMIN_ACCOUNT_LIST: `${microServices.USER_SERVICE}/super-admin/account/get`,
  SUPER_ADMIN_USERS_PER_ACCOUNT: `${microServices.USER_SERVICE}/super-admin/account/user-per-account`,
  SUPER_ADMIN_WALLET_INFO: `${microServices.USER_SERVICE_WALLET}/info`,
  SUPER_ADMIN_WALLET_CREDIT: `${microServices.USER_SERVICE_WALLET}/credit`,
  SUPER_ADMIN_WALLET_DEBIT: `${microServices.USER_SERVICE_WALLET}/debit`,
  SUPER_ADMIN_CAMPAIGN_PRICING_EMAIL: `${microServices.USER_CAMPAIGN_PRICING}/email`,
  SUPER_ADMIN_CAMPAIGN_PRICING_WHATSAPP: `${microServices.USER_CAMPAIGN_PRICING}/whatsapp`,
  SUPER_ADMIN_CAMPAIGN_PRICING_EMAIL_VALIDATION: `${microServices.USER_CAMPAIGN_PRICING}/email_validation`,
  SUPER_ADMIN_CAMPAIGN_PRICING_EMAIL_FINDER: `${microServices.USER_CAMPAIGN_PRICING}/email_finder`,
  SUPER_ADMIN_CAMPAIGN_PRICING_SMS: `${microServices.USER_CAMPAIGN_PRICING_ADMIN}/sms/pricing`,
  SUPER_ADMIN_CAMPAIGN_PRICING_WHATSAPP_2: `${microServices.USER_CAMPAIGN_PRICING_ADMIN}/whatsapp/pricing`,
  SUPER_ADMIN_CAMPAIGN_PRICING_RCS: `${microServices.USER_CAMPAIGN_PRICING_ADMIN}/rcs/pricing`,
  SUPER_ADMIN_UPDATE_CAMPAIGN_PRICING_SMS: `${microServices.USER_SERVICE}/super-admin/campaign/sms/update-account-gateway-price-map`,
  SUPER_ADMIN_UPDATE_CAMPAIGN_PRICING_WHATSAPP_2: `${microServices.USER_SERVICE}/super-admin/campaign/whatsapp/update-account-price-map`,
  SUPER_ADMIN_UPDATE_CAMPAIGN_PRICING_RCS: `${microServices.USER_SERVICE}/super-admin/campaign/rcs/update-account-price-map`,

  // campaign
  CAMPAIGN_LIST: `${microServices.USER_CAMPAIGN_PRICING_ADMIN}/list`,
  EMAIL_DETAILED_ANALYTICS_REPORT: `${microServices.USER_CAMPAIGN_PRICING_ADMIN}/list/detailed-analytics`,
  EMAIL_DETAILED_REPORT: `${microServices.USER_CAMPAIGN_PRICING_ADMIN}/list/detailed-report`,

  // account sessions
  SUPER_ADMIN_ACCOUNT_SESSIONS: `${microServices.USER_SERVICE}/super-admin/account/account-sessions`,

  // account settings
  USER_ACCOUNT_SETTINGS: `${microServices.USER_SERVICE}/super-admin/account/settings`,
  CRM_ACCOUNT_SETTINGS: `${microServices.CRM_ADMIN}/account-settings/:accountId`,

  //whatsapp account settings
  SUPER_ADMIN_WHATSAPP_ACCOUNT_LIST: `${microServices.USER_SERVICE}/super-admin/campaign/whatsapp/admin-whatsapp-accounts`,
  SUPER_ADMIN_WHATSAPP_ACCOUNT_COUNT: `${microServices.USER_SERVICE}/super-admin/campaign/whatsapp/admin-whatsapp-accounts-count`,

  // rcs bot configuration
  GET_RCS_BOT_CONFIGS: `${microServices.USER_CAMPAIGN_PRICING_ADMIN}/settings/rcs`,
  CREATE_RCS_BOT_CONFIG: `${microServices.USER_CAMPAIGN_PRICING_ADMIN}/settings/rcs`,
  UPDATE_RCS_BOT_CONFIG: `${microServices.USER_CAMPAIGN_PRICING_ADMIN}/settings/rcs`,
  DELETE_RCS_BOT_CONFIG: `${microServices.USER_CAMPAIGN_PRICING_ADMIN}/settings/rcs`,

  // account billing details
  SUPER_ADMIN_ACCOUNT_BILLING_DETAILS: `${microServices.USER_SERVICE}/super-admin/account/billingDetails`
};
